<template>
  <v-app>
    <v-main class="main-content">
      <v-app-bar color="#1945a3">
        <v-container class="d-flex justify-space-between align-center">
          <v-img src="https://grupomv.mx/images/logo2.png" max-width="80" contain class="mr-4"></v-img>

          <div>
            <v-btn icon href="https://www.facebook.com/share/12GUzZZtKYD/" target="_blank">
              <v-icon>mdi-facebook</v-icon>
            </v-btn>

            <!-- Botón WhatsApp -->
            <v-btn icon href="https://wa.link/plk405" target="_blank">
              <v-icon color="#25D366">mdi-whatsapp</v-icon>
            </v-btn>

            <v-btn icon href="https://mx.linkedin.com/company/grupo-mv-distribuciones" target="_blank">
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-app-bar>

      <v-container class="mt-10">
        <v-row class="align-center">
          <v-col cols="12" md="8" class="mb-0 pb-0">
            <v-carousel cycle hide-delimiters :interval="3000">
              <v-carousel-item v-for="(image, i) in images" :key="i" :src="image"></v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col>
            <v-card class="login-container">
              <v-img class="mx-auto my-4" max-width="150"
                src="https://mvexpress.mx/images/logosapp/logomv2.png"></v-img>

              <v-card-title class="text-center font-weight-bold text-h5">
                Iniciar Sesión
              </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field label="Correo Electrónico" v-model="email" :rules="[rules.required, rules.email]"
                    prepend-inner-icon="mdi-email-outline" outlined dense></v-text-field>

                  <v-text-field :type="showPassword ? 'text' : 'password'" label="Contraseña" v-model="password"
                    :rules="[rules.required]" prepend-inner-icon="mdi-lock-outline"
                    :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append-inner="showPassword = !showPassword" outlined dense></v-text-field>

                  <v-checkbox v-model="rememberEmail" label="Recordar correo" class="mb-2" dense></v-checkbox>

                  <!-- 🔥 Botones juntos -->
                  <div class="d-flex ga-3 mt-4 buttons-inline">
                

                    <v-btn color="blue" size="large" variant="" @click="registrologin">
                      <v-icon left>mdi-account-plus</v-icon>
                      Crear cuenta
                    </v-btn>
                        <v-btn :disabled="!valid" color="amber-darken-4" size="large" @click="login">
                      <v-icon left>mdi-login-variant</v-icon>
                      Ingresar
                    </v-btn>
                  </div>

                </v-form>
              </v-card-text>
            </v-card>
          </v-col>


        </v-row>
      </v-container>


    </v-main>
  </v-app>
</template>

<script>
import apiClient from "@/apiClient";
import Swal from "sweetalert2";
import { Storage } from "@capacitor/storage"; // <- Importamos Capacitor Storage
import { requestWebPushPermission } from "././../../firebase";
import axios from "axios";
import { useUserStore } from "../stores/userStore";
export default {
  data() {
    return {
      images: [
        "https://grupomv.mx/images/2025/login1.jpg",
        "https://grupomv.mx/images/2025/login2.jpg",
        "https://grupomv.mx/images/2025/login3.jpg",
        "https://grupomv.mx/images/2025/login4.jpg",
        "https://grupomv.mx/images/2025/login5.jpg",
        "https://grupomv.mx/images/2025/login6.png",
        "https://grupomv.mx/images/2025/login7.jpg",
        "https://grupomv.mx/images/2025/login8.jpg",
        "https://grupomv.mx/images/2025/login9.jpg",
        "https://grupomv.mx/images/2025/login10.jpg",
      ],
      email: "",
      password: "",
      valid: false,
      showPassword: false,
      rememberEmail: false,
      rules: {
        required: (value) => !!value || "Este campo es obligatorio.",
        email: (value) => /.+@.+\..+/.test(value) || "Ingrese un correo válido.",
      },
    };
  },
  async mounted() {
    const { value: token } = await Storage.get({ key: "auth_token" });

    if (token) {
      // Token existe, ir directo a la app sin pedir login
      this.$router.push("/home");
    }
  },
  async created() {
    // Cargar correo guardado desde Capacitor Storage al iniciar
    const { value } = await Storage.get({ key: "email" });
    if (value) {
      this.email = value;
      this.rememberEmail = true;
    }
  },

  methods: {
    // Registrar token FCM
    async registrarTokenFCM() {
      try {
        const fcmToken = await requestWebPushPermission();
        console.log("✅ Token FCM obtenido:", fcmToken);

        const userStore = useUserStore();
        const jwtToken = userStore.user?.token || localStorage.getItem("token");

        if (!jwtToken) {
          console.error("❌ No hay token JWT válido");
          return;
        }

        const headers = { Authorization: `Bearer ${jwtToken}` };
        console.log("📤 Headers que se enviarán:", headers);

        await axios.post(
          "https://mvexpress.mx/api/notificaciones/guardar-token",
          { token: fcmToken },
          { headers }
        );

        console.log("FCM Token enviado:", fcmToken);
        console.log("JWT Token usado:", jwtToken);

        console.log("✅ Token FCM enviado al backend correctamente");
      } catch (err) {
        console.error("❌ Error registrando token FCM:", err);
      }
    },

    // Guardar token en Capacitor Storage
    async guardarToken(token) {
      await Storage.set({ key: "auth_token", value: token });
    },

    validateForm() {
      // Validamos email y password usando reglas
      const emailValid = this.rules.email(this.email) === true;
      const passwordValid = this.rules.required(this.password) === true;
      this.valid = emailValid && passwordValid;
    },

      async login() {
  this.validateForm();
  if (!this.valid) {
    Swal.fire("Error", "Por favor completa el formulario correctamente.", "warning");
    return;
  }

  try {
    const response = await apiClient.post("https://mvexpress.mx/api/auth", {
      email: this.email,
      password: this.password,
    });

    const data = response.data;

    const userStore = useUserStore();
    userStore.user = { ...data, token: data.token };

    // Guardamos token
    await Storage.set({ key: "auth_token", value: data.token });
    localStorage.setItem("token", data.token);

    // Guardar correo
    if (this.rememberEmail) {
      await Storage.set({ key: "email", value: this.email });
    } else {
      await Storage.remove({ key: "email" });
    }

    this.$router.push("/home");

    setTimeout(() => {
      this.registrarTokenFCM();
    }, 500);

  } catch (error) {

    // 🔥🔥 IMPRIME TODO EL ERROR EN CONSOLA
    console.error("❌ Error en login:", error);
    console.log("🔍 Respuesta completa del servidor:", error.response);

    // ⚠️ Si el backend envía mensaje, úsalo. Si no, muestra el genérico.
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: error.response?.data?.message || "Error login",
          timer: 3000,
        });

  }
},


    saveUserData(user) {
      localStorage.setItem("user", JSON.stringify(user));
    },

    registrologin() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>

<style scoped>
/* ======== ZONA SEGURA DEL TELÉFONO ======== */
.v-carousel {
  height: 380px !important;
}

/* 🔥 Versión teléfono (móvil) — carrusel más pequeño pero visible */
@media (max-width: 600px) {
  .v-carousel {
    height: 200px !important;
    /* Ajusta entre 160–220 según te guste */
  }

  /* Ajustar imagenes internas para que nunca se corten feo */
  .v-carousel .v-img {
    object-fit: cover !important;
  }
}

.main-content {
  min-height: 100vh;
  padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
  background-image: url("https://mvexpress.mx/images/publicidad/patronazul.png");
  background-size: cover;


  background-repeat: no-repeat;
}

/* ======== AJUSTE DE BOTONES (PEGADOS AL CHECKBOX) ======== */
.buttons-login {
  margin-top: 8px !important;
  /* antes 24px */
  gap: 10px !important;
  /* espacio compacto */
}

.buttons-inline .v-btn {
  flex: 1;
  /* que ambos ocupen el mismo ancho */
}

/* ======== BOTÓN WHATSAPP MÁS PEQUEÑO ======== */
.whatsapp-float {
  position: fixed;
  width: 48px;
  /* más pequeño */
  height: 48px;
  right: 16px;
  bottom: 50px;
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  text-align: center;
  font-size: 24px;
  /* icono más pequeño */
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}


.v-app-bar {
  padding-top: env(safe-area-inset-top);
  height: calc(56px + env(safe-area-inset-top));
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

/* Para Samsung que no respeta env() */
@supports (bottom: env(safe-area-inset-bottom)) {
  .whatsapp-float {
    bottom: calc(max(env(safe-area-inset-bottom), 12px) + 12px);
  }
}

/* Ajuste del card */
.login-container {
  padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
}
</style>
